export default __webpack_public_path__ + "static/media/Receive.9059338e.svg";